/*import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, db, storage } from '../firebase';
import { collection, doc, setDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import styles from './form.module.css';

const InternshipApplicationForm = () => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    university: '',
    department: '',
    graduationYear: '',
    internshipPeriod: '',
    interestedDepartments: [],
    cv: null,
    motivationLetter: null,
    transcript: null,
  });
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (!user) {
        alert('Başvuru yapmak için önce giriş yapmalısınız.');
        navigate('/giris');
      }
    });
    return () => unsubscribe();
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const { name } = e.target;
    setFormData({ ...formData, [name]: e.target.files[0] });
  };

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    const { interestedDepartments } = formData;
    if (checked) {
      setFormData({ ...formData, interestedDepartments: [...interestedDepartments, value] });
    } else {
      setFormData({
        ...formData,
        interestedDepartments: interestedDepartments.filter((dept) => dept !== value),
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStep(step + 1);
  };

  const submitFormData = async (e) => {
    e.preventDefault();
    if (auth.currentUser) {
      try {
        const userId = auth.currentUser.uid;
  
        // Upload CV
        const cvUrl = await uploadFile(
          `stajcv/${userId}/${formData.cv.name}`,
          formData.cv
        );
  
        // Upload Motivation Letter (if provided)
        const motivationUrl = formData.motivationLetter
          ? await uploadFile(
              `stajmotivation/${userId}/${formData.motivationLetter.name}`,
              formData.motivationLetter
            )
          : null;
  
        // Upload Transcript (if provided)
        const transcriptUrl = formData.transcript
          ? await uploadFile(
              `stajtranscript/${userId}/${formData.transcript.name}`,
              formData.transcript
            )
          : null;
  
        // Save to Firestore
        await setDoc(doc(db, 'internshipApplications', userId), {
          userId,
          university: formData.university,
          department: formData.department,
          graduationYear: formData.graduationYear,
          internshipPeriod: formData.internshipPeriod,
          interestedDepartments: formData.interestedDepartments,
          cvUrl,
          motivationUrl,
          transcriptUrl,
          timestamp: new Date(),
        });
  
        alert('Başvurunuz başarıyla gönderildi!');
        navigate('/hesabim');
      } catch (error) {
        console.error('Error submitting form: ', error);
        alert('Bir hata oluştu. Lütfen tekrar deneyin.');
      }
    } else {
      alert('Lütfen giriş yapın.');
      navigate('/giris');
    }
  };
  const uploadFile = async (path, file) => {
    const fileRef = ref(storage, path);
    await uploadBytes(fileRef, file);
    return await getDownloadURL(fileRef);
  };
  

  const departments = ['Yönetim', 'Hukuk ve İç Denetim', 'Muhasebe-Finans', 'İnsan Kaynakları','IT - Bilgi Teknolojileri', 'Mobil Uygulama Geliştirme','Pazarlama','Kurumsal İletişim','İç Süreç Geliştirme','Müşteri Hizmetleri','Gayrimenkul','PDI - Kalite-Kontrol', 'Üretim','SMT Hattı','Depo','AR-GE','ÜR-GE - Üretim Planlama ve Geliştirme','ReeDükkan - Satış'];

  return (
    <main className={styles.main}>
      <section className={styles.section}>
        {step === 1 && (
          <form onSubmit={handleSubmit} className={styles.form}>
            <h1 className={styles.header}>Staj Başvuru Formu</h1>
            <div className={styles.formGroup}>
              <label className={styles.label}>Üniversite Adı:</label>
              <input
                type="text"
                name="university"
                value={formData.university}
                onChange={handleChange}
                required
                className={styles.input}
              />
            </div>
            <div className={styles.formGroup}>
              <label className={styles.label}>Bölüm:</label>
              <input
                type="text"
                name="department"
                value={formData.department}
                onChange={handleChange}
                required
                className={styles.input}
              />
            </div>
            <div className={styles.formGroup}>
              <label className={styles.label}>Mezuniyet Tarihi (Öngörülen):</label>
              <input
                type="number"
                name="graduationYear"
                value={formData.graduationYear}
                onChange={handleChange}
                required
                className={styles.input}
                min="2024"
                max="2100"
              />
            </div>
            <button type="submit" className={styles.button}>Devam Et</button>
          </form>
        )}

        {step === 2 && (
          <form onSubmit={handleSubmit} className={styles.form}>
            <h1 className={styles.header}>Staj Başvuru Formu</h1>
            <div className={styles.formGroup}>
              <label className={styles.label}>Staj Dönemi:</label>
              <select
                name="internshipPeriod"
                value={formData.internshipPeriod}
                onChange={handleChange}
                required
                className={styles.input}
              >
                <option value="">Seçiniz</option>
                <option value="1. Dönem">1. Dönem</option>
                <option value="2. Dönem">2. Dönem</option>
              </select>
            </div>
            <div className={styles.formGroup}>
              <label className={styles.label}>İlgilendiğiniz Departmanlar:</label>
              {departments.map((dept, index) => (
                <div key={index} className={styles.checkboxGroup}>
                  <input
                    type="checkbox"
                    value={dept}
                    onChange={handleCheckboxChange}
                    className={styles.checkbox}
                  />
                  <label>{dept}</label>
                </div>
              ))}
            </div>
            <button type="submit" className={styles.button}>Devam Et</button>
          </form>
        )}

        {step === 3 && (
          <div className={styles.form}>
            <h1 className={styles.header}>Belgeler Yükleme</h1>
            <div className={styles.formGroup}>
              <label className={styles.label}>CV:</label>
              <input
                type="file"
                name="cv"
                accept="application/pdf"
                onChange={handleFileChange}
                required
                className={styles.input}
              />
            </div>
            <div className={styles.formGroup}>
              <label className={styles.label}>Motivasyon Mektubu:</label>
              <input
                type="file"
                name="motivationLetter"
                accept="application/pdf"
                onChange={handleFileChange}
                className={styles.input}
              />
            </div>
            <div className={styles.formGroup}>
              <label className={styles.label}>Transcript:</label>
              <input
                type="file"
                name="transcript"
                accept="application/pdf"
                onChange={handleFileChange}
                className={styles.input}
              />
            </div>
            <button onClick={submitFormData} className={styles.button}>Başvuruyu Tamamla</button>
          </div>
        )}
      </section>
    </main>
  );
};

export default InternshipApplicationForm;*/

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, db, storage } from '../firebase';
import { doc, setDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import styles from './form.module.css';

const InternshipApplicationForm = () => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    university: '',
    department: '',
    graduationYear: '',
    internshipPeriod: '',
    interestedDepartments: [],
    cv: null,
    motivationLetter: null,
    transcript: null,
    answers: [],
  });
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    // Kullanıcı giriş kontrolü
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (!user) {
        alert('Başvuru yapmak için önce giriş yapmalısınız.');
        navigate('/giris');
      }
    });
    return () => unsubscribe();
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const { name } = e.target;
    setFormData({ ...formData, [name]: e.target.files[0] });
  };

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    const { interestedDepartments } = formData;
    if (checked) {
      setFormData({ ...formData, interestedDepartments: [...interestedDepartments, value] });
    } else {
      setFormData({
        ...formData,
        interestedDepartments: interestedDepartments.filter((dept) => dept !== value),
      });
    }
  };

  const handleSubmitStep1 = (e) => {
    e.preventDefault();
    setStep(2);
  };

  const handleSubmitStep2 = (e) => {
    e.preventDefault();
    setStep(3);
  };

  const handleAnswer = (answer) => {
    const updatedAnswers = [
      ...formData.answers,
      { question: questions[currentQuestion].text, answer },
    ];
    setFormData({ ...formData, answers: updatedAnswers });

    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      setStep(4);
    }
  };

  const submitFormData = async () => {
    if (auth.currentUser) {
      try {
        const userId = auth.currentUser.uid;

        // Upload CV
        const cvUrl = await uploadFile(
          `stajcv/${userId}/${formData.cv.name}`,
          formData.cv
        );

        // Upload Motivation Letter (if provided)
        const motivationUrl = formData.motivationLetter
          ? await uploadFile(
              `stajmotivation/${userId}/${formData.motivationLetter.name}`,
              formData.motivationLetter
            )
          : null;

        // Upload Transcript (if provided)
        const transcriptUrl = formData.transcript
          ? await uploadFile(
              `stajtranscript/${userId}/${formData.transcript.name}`,
              formData.transcript
            )
          : null;

        // Save to Firestore
        await setDoc(doc(db, 'internshipApplications', userId), {
          userId,
          university: formData.university,
          department: formData.department,
          graduationYear: formData.graduationYear,
          internshipPeriod: formData.internshipPeriod,
          interestedDepartments: formData.interestedDepartments,
          cvUrl,
          motivationUrl,
          transcriptUrl,
          answers: formData.answers,
          timestamp: new Date(),
        });

        alert('Başvurunuz başarıyla gönderildi!');
        navigate('/hesabim');
      } catch (error) {
        console.error('Error submitting form: ', error);
        alert('Bir hata oluştu. Lütfen tekrar deneyin.');
      }
    } else {
      alert('Lütfen giriş yapın.');
      navigate('/giris');
    }
  };

  const uploadFile = async (path, file) => {
    const fileRef = ref(storage, path);
    await uploadBytes(fileRef, file);
    return await getDownloadURL(fileRef);
  };

  const departments = [
    'Yönetim', 'Hukuk ve İç Denetim', 'Muhasebe-Finans', 'İnsan Kaynakları',
    'IT - Bilgi Teknolojileri', 'Mobil Uygulama Geliştirme', 'Pazarlama',
    'Kurumsal İletişim', 'İç Süreç Geliştirme', 'Müşteri Hizmetleri',
    'Gayrimenkul', 'PDI - Kalite-Kontrol', 'Üretim', 'SMT Hattı', 'Depo',
    'AR-GE', 'ÜR-GE - Üretim Planlama ve Geliştirme', 'ReeDükkan - Satış'
  ];

  
  const questions = [
    // Evet/Hayır Soruları
    { text: 'Şu anda aktif olarak bir işte çalışıyor musunuz?', type: 'yesno' },
    { text: 'İş deneyiminiz 5 yıldan fazla mı?', type: 'yesno' },
    { text: 'Yüksek düzeyde sorumluluk almak sizin için bir motivasyon kaynağı mıdır?', type: 'yesno' },
    { text: '"Tam bir takım oyuncusuyum" ifadesi sizin için doğru bir ifade mi?', type: 'yesno' },
    { text: 'Zorlu durumlarla karşılaştığınızda mücadele etmeyi tercih eder misiniz?', type: 'yesno' },
    { text: 'Okul yıllarınızda, akademik başarılarınızla tanınıyor muydunuz?', type: 'yesno' },
    { text: 'Kariyer hedeflerinizde "her zaman bir numara olmak" gibi bir hedefiniz var mı?', type: 'yesno' },
    { text: 'Hayatta dengeyi mi yoksa aşırıya gitmeyi mi tercih ediyorsunuz?', type: 'choice', choices: ['Denge', 'Aşırıya gitmek'] },
    { text: 'Sevdiğiniz bir konuda fanatik olma eğiliminde misiniz?', type: 'yesno' },
    { text: 'Buluşmalar ve toplantılar için genellikle erken gelir misiniz?', type: 'yesno' },
    { text: 'İş yerinde düzenli ve disiplinli çalışmayı tercih eder misiniz?', type: 'yesno' },
    { text: 'İşyerinde değişime kolay adapte olabilir misiniz?', type: 'yesno' },
    { text: 'Sigara kullanıyor musunuz?', type: 'yesno' },
    { text: 'Yeni sorumluluklar almak sizi heyecanlandırır mı?', type: 'yesno' },

    // Şıklı Sorular
    { text: 'Beklenmedik bir kriz durumunda stresli hissettiğinizde nasıl tepki verirsiniz?', type: 'choice', choices: [
        'Sakin kalır, çözüm için hızlıca plan yapar ve aksiyon alırım.',
        'Öncelikle stresimi yönetmeye çalışırım, ancak çözüm bulmada zorlanırım.',
        'Stres seviyem yüksek olursa, karar vermekte zorlanırım, bir süre duraksayabilirim.',
        'Stresli hissettiğimde paniğe kapılırım, çevremdeki kişilerin desteğine ihtiyaç duyarım.'
    ]},
    { text: 'Zorlu bir kriz sırasında hangi becerilerinizin daha çok işe yaradığını düşünüyorsunuz?', type: 'choice', choices: [
        'İletişim becerilerim ve problem çözme yeteneğim.',
        'Çabuk karar verme yeteneğim ve liderlik becerilerim.',
        'Sakin kalma yeteneğim ve olayları soğukkanlılıkla değerlendirme becerim.',
        'Takım çalışması ve işbirliği yapma becerim.'
    ]},
    { text: 'Aşağıdaki özelliklerden hangileri sizi en iyi tanımlar?', type: 'choice', choices: [
        'Sevgi, saygı, empati, dinleme',
        'Kararlılık, liderlik, yönetim, strateji',
        'Yaratıcılık, yenilikçilik, esneklik, risk alma',
        'Disiplin, planlama, zaman yönetimi, sorumluluk'
    ]},

    // Klasik Sorular
    { text: '2+2x5-1 işleminin sonucunu hesaplayınız.', type: 'text' },
    { text: 'Hayranlık duyduğunuz bir bilim insanı var mı? Adını paylaşabilir misiniz?', type: 'text' }
  ];

  return (
    <main className={styles.main}>
      <section className={styles.section}>
        {step === 1 && (
          <form onSubmit={handleSubmitStep1} className={styles.form}>
            <h1 className={styles.header}>Staj Başvuru Formu</h1>
            <div className={styles.formGroup}>
              <label className={styles.label}>Üniversite Adı:</label>
              <input
                type="text"
                name="university"
                value={formData.university}
                onChange={handleChange}
                required
                className={styles.input}
              />
            </div>
            <div className={styles.formGroup}>
              <label className={styles.label}>Bölüm:</label>
              <input
                type="text"
                name="department"
                value={formData.department}
                onChange={handleChange}
                required
                className={styles.input}
              />
            </div>
            <div className={styles.formGroup}>
              <label className={styles.label}>Mezuniyet Tarihi (Öngörülen):</label>
              <input
                type="number"
                name="graduationYear"
                value={formData.graduationYear}
                onChange={handleChange}
                required
                className={styles.input}
                min="2024"
                max="2100"
              />
            </div>
            <button type="submit" className={styles.button}>Devam Et</button>
          </form>
        )}

        {step === 2 && (
          <form onSubmit={handleSubmitStep2} className={styles.form}>
            <h1 className={styles.header}>Staj Başvuru Formu</h1>
            <div className={styles.formGroup}>
              <label className={styles.label}>Staj Dönemi:</label>
              <select
                name="internshipPeriod"
                value={formData.internshipPeriod}
                onChange={handleChange}
                required
                className={styles.input}
              >
                <option value="">Seçiniz</option>
                <option value="1. Dönem">1. Dönem</option>
                <option value="2. Dönem">2. Dönem</option>
              </select>
            </div>
            <div className={styles.formGroup}>
              <label className={styles.label}>İlgilendiğiniz Departmanlar:</label>
              {departments.map((dept, index) => (
                <div key={index} className={styles.checkboxGroup}>
                  <input
                    type="checkbox"
                    value={dept}
                    onChange={handleCheckboxChange}
                    className={styles.checkbox}
                  />
                  <label>{dept}</label>
                </div>
              ))}
            </div>
            <button type="submit" className={styles.button}>Devam Et</button>
          </form>
        )}

        {step === 3 && (
          <div className={styles.questionContainer}>
            <h1 className={styles.header}>Staj Başvuru Formu - Sorular</h1>
            <p className={styles.question}>{questions[currentQuestion].text}</p>
            {questions[currentQuestion].type === 'yesno' && (
              <>
                <button
                  onClick={() => handleAnswer('Evet')}
                  className={styles.answerButton}
                >
                  Evet
                </button>
                <button
                  onClick={() => handleAnswer('Hayır')}
                  className={styles.answerButton}
                >
                  Hayır
                </button>
              </>
            )}
            {questions[currentQuestion].type === 'choice' && (
              <>
                {questions[currentQuestion].choices.map((choice, index) => (
                  <button
                    key={index}
                    onClick={() => handleAnswer(choice)}
                    className={styles.answerButton}
                  >
                    {choice}
                  </button>
                ))}
              </>
            )}
            {questions[currentQuestion].type === 'text' && (
              <div className={styles.formGroup}>
                <input
                  type="text"
                  placeholder="Cevabınızı yazın"
                  onBlur={(e) => handleAnswer(e.target.value)}
                  className={styles.input}
                />
              </div>
            )}
          </div>
        )}

        {step === 4 && (
          <div className={styles.form}>
            <h1 className={styles.header}>Belgeler Yükleme</h1>
            <div className={styles.formGroup}>
              <label className={styles.label}>CV:</label>
              <input
                type="file"
                name="cv"
                accept="application/pdf"
                onChange={handleFileChange}
                required
                className={styles.input}
              />
            </div>
            <div className={styles.formGroup}>
              <label className={styles.label}>Motivasyon Mektubu:</label>
              <input
                type="file"
                name="motivationLetter"
                accept="application/pdf"
                onChange={handleFileChange}
                className={styles.input}
              />
            </div>
            <div className={styles.formGroup}>
              <label className={styles.label}>Transcript:</label>
              <input
                type="file"
                name="transcript"
                accept="application/pdf"
                onChange={handleFileChange}
                className={styles.input}
              />
            </div>
            <button onClick={submitFormData} className={styles.button}>
              Başvuruyu Tamamla
            </button>
          </div>
        )}
      </section>
    </main>
  );
};

export default InternshipApplicationForm;